import moment from 'moment-timezone'
// moment.tz.setDefault('Asia/Chita')

export const formatMinutes = mins => {
  return mins > 60
    ? `${Math.trunc(mins / 60)} ч ${mins % 60} мин`
    : `${mins} мин`
}

export const dateTo24hTime = date => {
  return date.toLocaleTimeString().slice(0, -3)
}

export const subtractingDates = (d1, d2) => {
  const mins = Math.round(Math.abs(new Date(d2) - new Date(d1)) / 60000)
  return mins > 60
    ? `${Math.trunc(mins / 60)} ч ${mins % 60} мин`
    : `${mins} мин`
}

export const subtractTime = (t1, t2) => {
  const t1P = t1.split(':')
  const t2P = t2.split(':')
  const t1M = (t1P[0] === '24' ? 0 : t1P[0]) * 60 + +t1P[1]
  const t2M = (t2P[0] === '24' ? 0 : t2P[0]) * 60 + +t2P[1]
  const sub = t2M - t1M
  return sub < 0 ? 1440 + t2M - t1M : sub
}

export const ritmDate = {
  toTimestamp(value) {
    let result = value
    if (!value) return null
    if (typeof value === 'number' || typeof value === 'boolean') {
      result = value
    } else if (typeof value === 'string') {
      if (value.includes('+')) {
        result = moment(value).valueOf()
      } else {
        if (value.length === 10) {
          const pre = value.includes('.') ? moment(value, 'DD.MM.YYYY').format('YYYY-MM-DD') : value
          result = moment(`${pre}T00:00:00+09`).valueOf()
        } else {
          const pre = value.includes('.') ? moment(value, 'DD.MM.YYYY HH:mm:ss').format('YYYY-MM-DD HH:mm:ss') : value
          result = moment(`${pre}+09`).valueOf()
        }
      }
    } else {
      if (typeof value.getMonth === 'function') {
        const format = `${value.getFullYear()}-${('0' + (value.getMonth() + 1)).slice(-2)}-${('0' + value.getDate()).slice(-2)}T${('0' + value.getHours()).slice(-2)}:${('0' + value.getMinutes()).slice(-2)}:${('0' + value.getSeconds()).slice(-2)}`
        const str = moment(`${format}+09`)
        result = str.valueOf()
      } else {
        result = moment(`${value.format('YYYY-MM-DD[T]HH:mm:ss+09')}`).valueOf()
      }
    }
    return result
  },
  diff(date, diff, unit) {
    return (diff) ? date.add(diff, unit || 's') : date
  },
  toIso(date = null, diff = null, unit = 's') {
    const timestamp = this.toTimestamp(date)
    const mom = timestamp ? moment(timestamp) : moment()
    const moment_date = this.diff(mom, diff, unit).tz('Asia/Chita')
    return moment_date.format('YYYY-MM-DD[T]HH:mm:ss')
  },
  toFormat(date, format = null, diff = null, unit = 's') {
    const timestamp = this.toTimestamp(date)
    const moment_date = this.diff(timestamp ? moment(timestamp) : moment(), diff, unit).tz('Asia/Chita')
    return !moment_date.isValid() ? '-' : moment_date.format(format || 'YYYY-MM-DD HH:mm:ss')
  },
  toUnix(date = null, diff = null, unit = 's') {
    const timestamp = this.toTimestamp(date)
    const moment_date = timestamp ? moment(timestamp) : moment()
    return this.diff(moment_date, diff, unit).valueOf()
  },
  date(date = null, h = null, m = null, s = null) {
    if (typeof date === 'boolean') return date

    const timestamp = this.toTimestamp(date)
    const moment_date = timestamp ? moment(timestamp) : moment()
    const result = moment_date.tz('Asia/Chita')
    if (h) result.set('hour', h)
    if (m) result.set('minute', m)
    if (s) result.set('second', s)
    return result.format('YYYY-MM-DD[T]HH:mm:ss')
  },
  dateDiff(date = null, diff = null, unit = 's') {
    const timestamp = this.toTimestamp(date)
    const moment_date = date ? moment(timestamp) : moment()
    const result = this.diff(moment_date.tz('Asia/Chita'), diff, unit)
    return result.format('YYYY-MM-DD[T]HH:mm:ss')
  }
}

if (ritmDate.toTimestamp('2024-11-14T17:29:00') !== 1731572940000) {
  console.error('test fail 0')
}
if (ritmDate.toTimestamp('2024-11-14T17:29:00+09') !== 1731572940000) {
  console.error('test fail 1')
}
const now = moment('2024-11-14T17:29:05+03')
if (ritmDate.toTimestamp(now) !== moment('2024-11-14T17:29:05+09').valueOf()) {
  console.error('test fail 2')
}
if (ritmDate.toTimestamp('2024-11-14 17:29:05+09') !== moment('2024-11-14T17:29:05+09').valueOf()) {
  console.error('test fail 2-1')
}
if (ritmDate.toTimestamp('2024-11-14 17:29:05') !== moment('2024-11-14T17:29:05+09').valueOf()) {
  console.error('test fail 2-2')
}
if (ritmDate.toTimestamp('14.11.2024 17:29:05') !== moment('2024-11-14T17:29:05+09').valueOf()) {
  console.error('test fail 2-3')
}
if (ritmDate.toTimestamp('14.11.2024 17:29') !== moment('2024-11-14T17:29:00+09').valueOf()) {
  console.error('test fail 2-4')
}
if (ritmDate.toTimestamp('14.11.2024') !== moment('2024-11-14T00:00:00+09').valueOf()) {
  console.error('test fail 2-5')
}

const now2 = new Date(Date.parse('2024-11-14T17:29:05.000+03:00'))
if (ritmDate.toTimestamp(now2) !== moment('2024-11-14T17:29:05+09').valueOf()) {
  console.error('test fail 3')
}

if (ritmDate.toFormat('2024-10-12', 'DD.MM.YYYY') !== '12.10.2024') {
  console.log(ritmDate.toFormat('2024-10-12', 'DD.MM.YYYY'))
  console.error('test fail 4')
}

export const rDate = {
  date: null,
  offset: -9,
  userOffset: null,
  spare: '—',
  parsed: null,
  result: null,
  ISO: null,
  units: {
    day: 24 * 60 * 60 * 1000,
    days: 24 * 60 * 60 * 1000,
    hour: 60 * 60 * 1000,
    minute: 60 * 1000,
    second: 1000
  },
  _split: (date, offset, userOffset) => {
    const weekDayNames = ['Вс', 'Пн', 'Вт', 'Ср', 'Чт', 'Пт', 'Сб']
    const monthNames = [
      'Январь',
      'Февраль',
      'Март',
      'Апрель',
      'Май',
      'Июнь',
      'Июль',
      'Август',
      'Сентябрь',
      'Октябрь',
      'Ноябрь',
      'Декабрь'
    ]

    const twoDigit = v => {
      return v >= 10 ? v : `0${v}`
    }

    const getOffset = (offset, userOffset) => {
      const os = userOffset ?? offset
      const h = Math.abs(Math.floor(os))
      const m = Math.abs((os % 1).toFixed(1) * 10)
      return `${os >= 0 ? '-' : '+'}${twoDigit(h)}:${twoDigit(m)}`
    }

    if (typeof userOffset === 'number') {
      const h = date.getHours()
      const abs = Math.abs(userOffset)
      const o = userOffset >= 0 ? h - abs : h + abs
      date.setHours(offset + o)
    }

    const year = date.getFullYear()
    const month = date.getMonth()
    const dateNumber = date.getDate()
    const day = date.getDay()
    const hours = date.getHours()
    const minutes = date.getMinutes()
    const seconds = date.getSeconds()

    return {
      YYYY: year,
      YY: String(year).slice(2, 4),
      MMMM: monthNames[month],
      MMM: monthNames[month]?.slice(0, 3),
      MM: twoDigit(month + 1),
      M: month + 1,
      DD: twoDigit(dateNumber),
      D: dateNumber,
      dd: weekDayNames[day],
      HH: twoDigit(hours),
      h: hours % 12 || 12,
      mm: twoDigit(minutes),
      ss: twoDigit(seconds),
      offset: getOffset(offset, userOffset),
      _instance: date
    }
  },
  _reset() {
    this.spare = '—'
    this.date = null
    this.parsed = null
    this.userOffset = null
  },
  _getOffset() {
    this.spare = '—'
    this.date = null
    this.parsed = null
    this.userOffset = null
  },
  _isValid: d => {
    const date = new Date(d)
    return d && !isNaN(Date.parse(date))
  },
  _parseMask(m, parsedDate) {
    let mask = m
    const keys = Object.keys(parsedDate)
    keys.forEach(k => {
      mask = mask.replace(k, parsedDate[k])
    })
    this._reset()
    return mask
  },
  getIso(parsedDate) {
    const { YYYY, MM, DD, HH, mm, ss, offset } = parsedDate
    return `${YYYY}-${MM}-${DD}T${HH}:${mm}:${ss}${offset}`
  },
  Iso(in_time, minutes = null) {
    const time = new Date(in_time)
    if (minutes) {
      time.setMinutes(time.getMinutes() + minutes)
    }
    return time.toISOString()
  },
  format(d, m, spare) {
    if (arguments.length === 1 && typeof d === 'string' && !this._isValid(d)) {
      m = d
      d = undefined
    }
    if (spare) this.spare = spare

    if (!d && !this._isValid(this.date)) return this.spare
    if (d) {
      this.date = new Date(d)
    }
    this.parsed = Date.parse(this.date)

    if (m === 'x') return this.parsed

    const { offset, userOffset, date } = this
    // const isoOffest = d.match(/([\+-][0-9]{2}\:)/)?.[0]?.replace(':', '')
    const parsedDate = this._split(date, offset, userOffset)

    this.ISO = this.getIso(parsedDate)
    let result

    if (m?.toUpperCase() === 'ISO') {
      this._reset()

      result = this.ISO
    } else {
      let mask
      if (m !== 'l') {
        mask = m || 'DD.MM.YYYY • HH:mm'
      } else mask = 'D/M/YY'
      result = this._parseMask(mask, parsedDate)
    }
    return result
  },
  // Chaining items
  zone(offset) {
    this.userOffset = offset
    return this
  },
  calc(quantity, unit, date) {
    this.date = date
      ? this._isValid(date)
        ? new Date(date)
        : this.date
      : this.date

    if (!this.date) return this

    const u = this.units[unit]
    const time = this.date.getTime()
    this.date.setTime(time + quantity * u)

    return this
  },
  zeroing(date) {
    this.date = date
      ? this._isValid(date)
        ? new Date(date)
        : this.date
      : this.date

    if (!this.date) return this

    this.date.setHours(0)
    this.date.setMinutes(0)
    this.date.setSeconds(0)
    return this
  },
  // Helpers
  secondsToTime: initial => {
    const twoDigit = v => {
      return v >= 10 ? v : `0${v}`
    }

    const hours = Math.floor(initial / (60 * 60))
    const divisor_for_minutes = initial % (60 * 60)
    const minutes = Math.floor(divisor_for_minutes / 60)
    const divisor_for_seconds = divisor_for_minutes % 60
    const seconds = Math.ceil(divisor_for_seconds)

    return `${twoDigit(hours)}:${twoDigit(minutes)}:${twoDigit(seconds)}`
  }
}
